import { Helpers } from '@utils/helpers';
import { get } from 'lodash';
export class PageLayerObject {
  brand: string;
  country: string;
  errorCode: string;
  errorMessage: string;
  language: string;
  navLevel1: string;
  navLevel2: string;
  navLevel3: string;
  navLevel4: string;
  navLevel5: string;
  siteID: string;
  type: string;
  constructor(initital: any) {
    this.brand = get(initital, 'brand', 'aviva');
    this.country = get(initital, 'country', 'sg');
    this.errorCode = get(initital, 'errorCode', '');
    this.errorMessage = get(initital, 'errorMessage', '');
    this.language = get(initital, 'language', 'en-sg');
    this.navLevel1 = get(initital, 'navLevel1', );
    this.navLevel2 = get(initital, 'navLevel2', '');
    this.navLevel3 = get(initital, 'navLevel3', '');
    this.navLevel4 = get(initital, 'navLevel4', '');
    this.navLevel5 = get(initital, 'navLevel5', '');
   
    const siteID = this.getSideId();
    console.log(siteID);
    this.siteID = get(initital, 'siteID', siteID);
    this.type = get(initital, 'type', Helpers.getPlatform());
  }

  private getSideId(): string {
    const path = window.location.href || '';
    if (path.includes('dpi')) {
      return 'qb-dpi';
    }
    if (path.includes('mltc')) {
      return 'qb-mltc';
    }
    return  'qb-sio';
  }
}
export class FormLayerObject {
  name: string;
  field: {
    marritalstaus: string;
    Gender: string;
  }
  error: {
    fieldLabels: string;
    messages: string;
    numErrors: string;
  }
  constructor(initial: any) {
    this.name = get(initial, 'name', '');
    this.field = get(initial, 'field',  {
      marritalstaus: '',
      Gender: ''
    });
    this.error = get (initial, 'error', {
      fieldLabels: '',
      messages: '',
      numErrors: ''
    });
  }
}
export class AcquisitionLayerObject {
  insurance: {
    paymentOptions: string;
    paymentType: string;
    paymentMethod: string;
    premium: string;
    coverOption: string;
    premiumTerm: string;
    monthlyPayout: string;
    promocode: string;
    campaignCode: string;
    sumassured: string;
    addOns: { name: string, price: string }[];
  }
  customer: {
    marketingOptIn: string[];
  }
  product: {
    policyID: string;
    prodID: string;
    prodName: string;
  }

  constructor(initial: any) {
    this.insurance = get(initial, 'insurance', {
      paymentOptions: '',
      paymentType: '',
      paymentMethod: '',
      premium: '',
      coverOption: '',
      premiumTerm: '',
      monthlyPayout: '',
      promocode: '',
      sumassured: '',
      addOns: [{ name: '', price: '' }]
    });
    this.customer = get(initial, 'customer',  {
      marketingOptIn: [],
    });
    this.product = get (initial, 'product', {
      policyID: '',
      prodID: '',
      prodName: ''
    });
  }
 

}
export class DataLayer {
  public page: PageLayerObject;
  public control: { versionNum: string };
  public acquisition: AcquisitionLayerObject; 
  public form: FormLayerObject;
  public user: {
    person: { age: string } 
  }
  constructor(initial: any) {
    this.control = {
      versionNum: process.env.REACT_APP_VERSION || '0.0'
    };
    this.page = get(initial, 'page', '');
    this.acquisition = get(initial, 'acquisition', '');
    this.form = get(initial, 'form', '');
    this.user = get(initial, 'user', {
      person: { age: '' }
    });

  }
}